(function() {
  'use strict';

  var items = document.querySelectorAll('.x-megamenu-lazy');

  items.forEach(function(item) {
    var loaded = false;

    function load() {
      if (loaded) return;
      loaded = true;

      var template = item.querySelector('.x-megamenu-template');
      if (!template) return;

      var content = template.content.cloneNode(true);
      item.appendChild(content);
      template.remove();
    }

    item.addEventListener('mouseenter', load, { once: true });
    item.addEventListener('focusin', load, { once: true });
    item.addEventListener('touchstart', load, { once: true, passive: true });
  });
})();
